import { render, staticRenderFns } from "./viewBillDetail.vue?vue&type=template&id=6e502f28"
import script from "./viewBillDetail.vue?vue&type=script&lang=js"
export * from "./viewBillDetail.vue?vue&type=script&lang=js"
import style0 from "./viewBillDetail.vue?vue&type=style&index=0&id=6e502f28&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports